module.exports = __webpack_public_path__ + "static/media/ic_text_selected.0abc1185.svg";